import { cache } from "react";

const getPreviewContext = cache(() => ({ isPreview: false }));

export function setPreviewMode() {
  getPreviewContext().isPreview = true;
}

export function isPreviewMode(): boolean {
  return getPreviewContext().isPreview;
}
